import { Box } from '@mui/material'
import { openSyntheticDataDocumentSection } from '@/features/documentPreview/openSyntheticDataDocumentSection'
import { inlineCodeSx } from '../inlineCodeSx'
import { docSectionId, isDocRef, safeHref } from './safeHref'
import styles from '../FormattedAgentText.module.scss'

const linkSx = { color: 'var(--app-primary)', textDecorationColor: 'currentColor' }

/** @param {{ token: { kind: string, text: string, href?: string } }} props */
export default function InlineToken({ token }) {
  const { kind, text, href } = token

  if (kind === 'bold') return <Box component="strong" sx={{ fontWeight: 650 }}>{text}</Box>
  if (kind === 'italic') return <Box component="em" sx={{ fontStyle: 'italic' }}>{text}</Box>
  if (kind === 'strike') return <Box component="del">{text}</Box>
  if (kind === 'code') return <Box component="code" sx={inlineCodeSx}>{text}</Box>

  if (kind === 'link') {
    if (isDocRef(href)) {
      return (
        <button
          type="button"
          className={styles.docRef}
          onClick={() => openSyntheticDataDocumentSection(docSectionId(href))}
          aria-label={`Open document section: ${text}`}
        >
          {text}
        </button>
      )
    }
    const url = safeHref(href)
    // A rejected scheme degrades to its label. Rendering a dead anchor would
    // look identical to a working one.
    if (!url) return <span>{text}</span>
    return (
      <Box component="a" href={url} target="_blank" rel="noopener noreferrer" sx={linkSx}>
        {text}
      </Box>
    )
  }

  return <span>{text}</span>
}
